import { reactive } from 'vue'

export const store = reactive({
    step: 'loading', // 'loading' | 'reservation' | 'recommendation'
    setStep: (step) => store.step = step,

    brand: null,
    setBrand: (brand) => store.brand = brand,

    submissionId: null,
    setSubmissionId: (id) => store.submissionId = id,
})

export default store